import ArrowLeftIcon from "@/assets/icons/ArrowLeft";
import Close from "@/assets/icons/Close";
import Info from "@/assets/icons/Info";
import AppButton from "@/components/shared/AppButton";
import { Box } from "@/components/ui/box";
import { Divider } from "@/components/ui/divider";
import { Heading } from "@/components/ui/heading";
import { Modal, ModalBackdrop, ModalBody, ModalCloseButton, ModalContent, ModalFooter } from "@/components/ui/modal";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { t } from "@transifex/native";
import { T } from "@transifex/react";

interface PlateWithWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  qrLotName: string;
  cameraLotName: string;
  className?: string;
  onConfirm: () => void;
}

const PlateWithWarningModal = ({ isOpen, onClose, qrLotName, cameraLotName, onConfirm, className }: PlateWithWarningModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalBackdrop />
      <ModalContent size="lg" className={`bg-background-100 max-w-md mx-auto rounded-2xl p-0 ${className}`}>
        <ModalCloseButton onPress={onClose} className="absolute top-4 right-4 z-10" data-test-id="close-button">
          <Close width={24} height={24} fill="text-typography-800" />
        </ModalCloseButton>

        <ModalBody className="py-8 px-5 m-0">
          <VStack className="gap-4">
            <Box className="items-center" data-test-id="info-icon">
              <Info width={20} height={20} />
            </Box>

            <Box>
              <Heading className="text-center text-typography-900 text-lg leading-6">
                <T _str="Warning" />
              </Heading>
              <Heading className="text-center text-typography-900 text-lg leading-6">
                <T _str="Lot Mismatch Detected" />
              </Heading>
            </Box>

            <Box className="gap-5">
              <Text className="text-typography-900 text-sm text-center leading-4">
                <T
                  _str="It looks like you're trying to activate a pass for the {qrLotName}, but our systems indicate that your vehicle may be located in the {cameraLotName}."
                  qrLotName={<Text className="text-typography-900 text-sm text-center leading-4 font-bold">{qrLotName}</Text>}
                  cameraLotName={<Text className="text-typography-900 text-sm text-center leading-4 font-bold">{cameraLotName}</Text>}
                />
              </Text>
              <Text className="text-typography-900 text-sm text-center leading-4">
                <T _str="Parking in an incorrect location or paying the incorrect rate will result in fines and/or the vehicle being towed, at the owner’s expense." />
              </Text>
            </Box>
          </VStack>
        </ModalBody>

        <Divider className="bg-secondary-600" />

        <ModalFooter className="w-full border-secondary-400">
          <Box className="py-4 px-5 flex-row w-full gap-x-3">
            <AppButton title={t("Back")} variant="outline" icon={ArrowLeftIcon} onPress={onClose} className="flex-grow-0 flex-shrink" />
            <AppButton title={t("Proceed Anyways")} onPress={onConfirm} className="flex-1" />
          </Box>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default PlateWithWarningModal;
